<template>
  <div id="dynamic-component-demo" class="demo">
    <button
      v-for="tabObj in tabObjects"
      v-bind:key="tabObj.id"
      v-bind:class="['tab-button', { active: currentTab === tabObj.id }]"
      v-on:click="currentTab = tabObj.id"
    >
      {{ tabObj.name }}
    </button>
    <component v-bind:is="currentTabComponent" class="tab"></component>
  </div>
</template>

<script>
import TabHome from './TabHome.vue'
import TabSome from './TabSome.vue'
import TabComment from './TabComment.vue'

  export default {
    name: 'TopPage',
    components: {
      TabHome,
      TabSome,
      TabComment
    },
    data() {
      return {
      currentTab: "Home",
      tabObjects:[
        {id:"Home",name:"ホーム"},
        {id:"Some",name:"ランキング"},
        {id:"Comment",name:"つぶやき"},
      ],
      tabs: ["Home", "Some", "Comment"]
      }
    },
    computed: {
      currentTabComponent: function () {
        return "Tab" + this.currentTab;
    }
    }
  }
  </script>

<style lang="scss" scoped>
      .tab-button {
        width: 33.3%;
        height: 60px;
        padding: 6px 10px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border: 1px solid #ccc;
        cursor: pointer;
        color: #fff;
        font-size: 20px;
        background: #82c56b;
        margin-bottom: -1px;
        margin-right: -1px;
      }
      .tab-button:hover {
        background: #249900;
      }
      .tab-button.active {
        background: #249900;
      }
      .fixed {
position: fixed; /* 要素の位置を固定する */
top: 0; /* 基準の位置を画面の一番上に指定する */
left: 0; /* 基準の位置を画面の一番左に指定する */
margin: 0; /* 要素の余白を０にする */
padding: 10px; /* 要素内側の余白を指定する */
height:30px; /* 高さを指定する */
width: 100%; /* 幅を指定する */
background: #326693; /* 背景色を指定する */
color:white; /* フォントの色を指定する */
}

</style>
